function footer() {
    const groups = document.querySelectorAll('.toptech-footer-group');
    if (!groups.length) return;

    const mobileViewport = window.matchMedia('(max-width: 768px)');
    const syncGroups = (isMobile) => {
        groups.forEach((group) => {
            group.open = !isMobile;
        });
    };

    syncGroups(mobileViewport.matches);
    if (mobileViewport.addEventListener) {
        mobileViewport.addEventListener('change', (event) => syncGroups(event.matches));
    } else {
        mobileViewport.addListener((event) => syncGroups(event.matches));
    }
}

export {footer};
